/** @format */

import React from "react";
import Amuqorakol from "./Amuqorakol";
import Shoxruddostlik from "./Shoxruddostlik";
import Xarxorduoba from "./Xarxorduoba";
import { exit } from "../../../../components/functions/Exit";
import {user_data} from "../../../../components/functions/usr";

// const regionComponents = {
//   1: Amuqorakol,
//   2: Shoxruddostlik,
//   3: Xarxorduoba,
// };

function Dashboard({ itbId, date }) {
  // const RegionComponent = regionComponents[itbId];
  // if (RegionComponent) {
  //   return <RegionComponent date={date} />;
  // }
  // exit();
  // return null;

  const name = user_data();

    const styles = {
        dashboard: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "80vh",
        },
        card: {
            background: "#ffffff",
            padding: "35px 45px",
            borderRadius: "14px",
            boxShadow: "0 15px 35px rgba(0, 0, 0, 0.08)",
            maxWidth: "650px",
            width: "100%",
            textAlign: "center",
        },
        title: {
            marginBottom: "20px",
            color: "#2c3e50",
        },
        text: {
            marginBottom: "15px",
            lineHeight: "1.6",
            color: "#555",
        },
        info: {
            marginTop: "15px",
            fontSize: "15px",
        },
    };

  return(
      <div style={styles.dashboard}>
          <div style={styles.card}>
              <h2 style={styles.title}>Dashboard</h2>

              <p style={styles.text}>
                  ⚙️ Tizim hozirda <strong>test rejimida</strong> ishlamoqda.
                  Foydalanish juda oson: asosiy manbalar menyusiga kirib,
                  kerakli sanani tanlang va ma’lumotlarni saqlang.
              </p>

              <p style={styles.text}>
                  📊 Kiritilgan ma’lumotlar havza boshqarmasida avtomatik
                  shakllantiriladi.
              </p>

              <hr />

              <div style={styles.info}>
                  <p><strong>Sana:</strong> {date}</p>
                  <p><strong>F.I.O:</strong> {name?.fio}</p>
              </div>
          </div>
      </div>
  )
}

export default Dashboard;
